import React from "react";

export const CaptainBandIcon = () => <svg viewBox="64.166 157.834 381.076 112.469">
    <rect x="64.166" y="157.834" width="100%" height="100%" rx="11" ry="11" style={{"stroke": "rgb(0, 0, 0)", "fill": "rgba(246, 230, 0, 0.64)"}}></rect>
    <ellipse style={{"stroke": "rgb(0, 0, 0)", "fill": "rgb(255, 255, 255)"}} cx="257.187" cy="213.951" rx="58.161" ry="55.368"></ellipse>
    <text style={{"fill": "rgb(51, 51, 51)", "fontFamily": "Arial, sans-serif", "fontSize": "94px", "whiteSpace": "pre"}} x="222.881" y="247.174">C</text>
</svg>
